//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {callApp, isApp, isWx, shareFun} from '@/util/const'
import shareDownload from '../shareDownload'
import step2 from './component/step2'
import step3 from './component/step3'
import step4 from './component/step4'
import step5 from './component/step5'
import step6 from './component/step6'
import process from './component/process'

export default {
    components: {
        step2,
        step3,
        step4,
        step5,
        step6,
        process,
        shareDownload
    },
    data () {
        return {
            prepare: [
                {
                    title: this.$t('greenchannelpassing.c3'),
                    desc: this.$t('greenchannelpassing.c4'),
                    more: false,
                    show: false
                },
                {
                    title: this.$t('greenchannelpassing.c5'),
                    desc: this.$t('greenchannelpassing.c6'),
                    more: true,
                    show: false
                },
                {
                    title: this.$t('greenchannelpassing.c7'),
                    desc: this.$t('greenchannelpassing.c8'),
                    more: true,
                    show: false
                },
                {
                    title: this.$t('greenchannelpassing.c9'),
                    desc: `${this.$t('greenchannelpassing.c10')}<br><br><a href="https://mylink.komect.com//roam/#/package?id=72&prId=21&choose=201581
"><img src="${this.$t('greenchannelpassing.c42')}" width="100%" class="product"></a>
            <br>
            <a href="https://mylink.komect.com//roam/#/package?id=72&prId=26&choose=200612"><img src="${this.$t('greenchannelpassing.c43')}" width="100%" class="product"></a>`,

                    more: true,
                    show: false
                },
                {
                    title: this.$t('greenchannelpassing.c11'),
                    desc: this.$t('greenchannelpassing.c12'),
                    more: true,
                    show: false
                },
                {
                    title: this.$t('greenchannelpassing.c13'),
                    desc: this.$t('greenchannelpassing.c14'),
                    more: true,
                    show: false
                }
            ],
        }
    },
    created () {
        shareFun({
            type: 1,
            url: `${location.origin}${location.pathname}#/passing`,
            title: `${this.$t('greenchannel.sharetitle1')}`,
            img: `https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/shareLogo/shareLogo`,
            content: `${this.$t('greenchannel.sharecontent1')}`
        })
    },
    methods: {
        change (index) {
            this.prepare[index].show = !this.prepare[index].show
        },
        goto (num) {
            if (num == 1) {
                document.body.scrollTop = document.documentElement.scrollTop = document.querySelectorAll('.title')[1].offsetTop
            } else {
                document.body.scrollTop = document.documentElement.scrollTop = 100
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/page/greenchannel/passing.vue